import { useEffect, useRef } from 'react';
import './CheckboxComponent.css';

const CheckboxComponent = ({
    label,
    checked,
    onChange,
    error,
    indeterminate = false,
    disabled = false,
    style = {},
    ...props
}) => {

    const checkboxRef = useRef(null);

    useEffect(() => {
        if (checkboxRef.current) {
            checkboxRef.current.indeterminate = indeterminate;
        }
    }, [indeterminate]);


    const handleChange = (e) => {
        onChange && onChange(e);
    };

    return (
        <div className="checkbox-container" style={style}>
            <div className="checkbox-wrapper">
                <label className={`checkbox-label ${error ? 'error' : ''} ${disabled ? 'disabled' : ''}`}>
                    <input
                        ref={checkboxRef}
                        type="checkbox"
                        checked={checked}
                        onChange={handleChange}
                        disabled={disabled}
                        className="checkbox-input"
                        {...props}
                    />
                    <span className="checkbox-custom"></span>
                    {label && <span className="checkbox-label-text">{label}</span>}
                </label>
            </div>
        </div>
    );
};

export default CheckboxComponent;
